import React, { useContext, useEffect, useState } from 'react'
import {
  Alert,
  Button,
  LinearProgress,
  Paper,
  Stack,
  Typography,
} from '@mui/material'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import moment from 'moment'
import API from '../../../services/API'
import { TenantSettingsContext } from '../../../App'
import PermissionCheck from '../../../helpers/PermissionCheck'
import { downloadPdf } from '../../../helpers/downloadPdf'
import CQCPackPDF from './CQCPackPDF'

const CqcPackPage = () => {
  const [pack, setPack] = useState(null)
  const [loading, setLoading] = useState(true)
  const [generating, setGenerating] = useState(false)
  const { orgConfig } = useContext(TenantSettingsContext)

  useEffect(() => {
    API.get('/cqc-centre/pack-data')
      .then((res) => {
        if (res.status === 200) setPack(res.data)
      })
      .catch((e) => console.log(e))
      .finally(() => setLoading(false))
  }, [])

  const handleDownload = async () => {
    setGenerating(true)
    try {
      await downloadPdf(
        <CQCPackPDF pack={pack} orgSettings={orgConfig?.orgSettings} />,
        `CQC Inspection Pack - ${moment().format('YYYY-MM-DD')}.pdf`,
      )
    } finally {
      setGenerating(false)
    }
  }

  return (
    <PermissionCheck roles={['Governance']} showAlert>
      <Stack gap={2}>
        <Typography variant="title1">Inspection Pack</Typography>
        <Alert severity="info" variant="outlined">
          A point-in-time pack containing what an inspector needs to see:
          readiness scores, the regulation-by-regulation compliance
          self-assessment, workforce assurance (DBS, training, appraisals),
          fleet and equipment currency, policy/SOP and risk registers,
          incident and complaint summaries, and the full evidence index. It
          is a self-assessment document, not confirmation of CQC compliance.
        </Alert>
        {loading && <LinearProgress />}
        {!loading && pack && (
          <Paper variant="outlined" sx={{ p: 3 }}>
            <Stack gap={1}>
              <Typography variant="body1">
                Overall Readiness:{' '}
                <strong>{pack.scores.overallScore} / 100</strong>
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {pack.evidenceItems.length} evidence items -{' '}
                {pack.openGaps.length} open gaps
                {pack.complianceQuestions
                  ? ` - ${pack.complianceQuestions.filter((q) => q.answered).length}/${pack.complianceQuestions.length} compliance questions answered`
                  : ''}
              </Typography>
              <Button
                variant="contained"
                startIcon={<PictureAsPdfIcon />}
                onClick={handleDownload}
                disabled={generating}
                sx={{ mt: 1, alignSelf: 'flex-start' }}
              >
                {generating ? 'Generating…' : 'Download Inspection Pack (PDF)'}
              </Button>
            </Stack>
          </Paper>
        )}
      </Stack>
    </PermissionCheck>
  )
}

export default CqcPackPage
